import { Controller } from '@hotwired/stimulus';
import { WebViewEvent, checkIfWebView } from '@infakt/webview-toolkit';

export default class extends Controller {
  static values = {
    url: String,
  };

  sendEvent(event) {
    if (!checkIfWebView()) {
      return;
    }

    event.preventDefault();

    return new WebViewEvent({
      event: 'OpenObrOnboarding',
      params: {
        url: this.urlValue,
      },
    }).dispatch();
  }
}
